const resourceMessageMap: Partial<
  Record<
    string,
    {
      message: any;
      time: number;
    }
  >
> = {};

export const getResourceMessage = (id: string | number) => {
  const { message, time } = resourceMessageMap[id] || {};
  if (time && Date.now() - time < 10 * 1000) {
    return message;
  }
  return undefined;
};
export const addResourceMessage = (id: string | number, message: any) =>
  (resourceMessageMap[id] = {
    message,
    time: Date.now(),
  });
export const deleteResourceMessage = (id: string | number) => delete resourceMessageMap[id];
